import styled from "styled-components";
import { colors } from "../../../utils";
import { ASSETS } from "../../../utils/config";
import { sliderToOpacity } from "../../../utils/helpers";

export const Wrapper = styled.div`
  width: 100vw;
  max-height: 100svh;
  overflow: scroll;

  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  /* Hide scrollbar for WebKit browsers (Chrome, Safari) */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  /* Hide scrollbar for Firefox */
  scrollbar-width: none;
`;

export const Header = styled.div`
background-color:  #ffffff80;
  margin-top: ${({ hideView }) => (hideView ? '-15vh' : '0svh')};
  margin-top: ${({ hideView }) => (hideView ? '-18svh' : '0svh')};
  transition: margin-top 0.3s ease-in-out;
  position: relative;
  z-index: 100;
`;

export const ContentView = styled.div`
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  min-height: calc(100vh - 23vh);
  min-height: calc(100svh - 18svh);
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  /* z-index: -1; */
  width: 100%;
  background: ${({ currentBg, bgWallpaper, color }) => {
    if ((currentBg === 2 || currentBg === 3) && bgWallpaper !== "") {
      return currentBg === 2 ? `url(${bgWallpaper})` : bgWallpaper;
    } else if (currentBg === 0 && !color) {
      return `url(${ASSETS.segmentEditor.DefaultWallpaperForViewWheel})`;
    }
    return color;
  }};
  object-fit: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover; /* Change from 100% 100% to cover */
  opacity: ${({ wallpaperTransparency }) =>
    sliderToOpacity(wallpaperTransparency)};
  filter: hue-rotate(${({ wallpaperHuePercentage }) =>
    ((wallpaperHuePercentage ?? 0) / 100) * 360}deg);
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ wallpaperHueColor }) =>
      wallpaperHueColor ?? "#ffffff"};
    opacity: ${({ wallpaperHuePercentage }) =>
      ((wallpaperHuePercentage ?? 0) / 100) * 0.5};
    mix-blend-mode: multiply;
    pointer-events: none;
  }
`;

export const IconsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  background-color: #ffffffe5;
  border-bottom: 1px solid #e1e1e1;
  height: 6vh;
  height: 8svh;
`;

export const IconWrapper = styled.div`
  height: 42px;
  width: 42px;
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 3px;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px;
  transition: box-shadow 0.2s ease;
  cursor: pointer;

  &:active {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
`;

export const WheelView = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const SegmentListButton = styled.div`
  background-color: #ffffffc2;
  border-radius: 20px;
  padding: 8px 16px 8px 16px;
  gap: 10px;
  border-radius: 100px;
  align-self: flex-end;
  margin-bottom: -20px;
  z-index: 20;
`;

export const NotificationBar = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  position: absolute;
  top: 0;
  background-color: #ffffffe5;
  border-radius: 0px 0px 24px 24px;
  padding: 16px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  z-index: 500;
`;

export const TextContainer = styled.div`
  background: var(--Green-500, #b9d645);
  padding: 12px 20px 12px 20px;
  gap: 20px;
  border-radius: 8px;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ToggleLabelIcon = styled.img`
  margin: 10px 10px 10px 10px;
`;

export const ToggleLabelIconContainer = styled.div`
  position: absolute;
  right: 4vw;
  top: 12svh;
  z-index: 10;
  cursor: pointer;
  background-color: white;
  border-radius: 5px;
`;
